// Modules:
import React, { useContext } from 'react';

// Mui:
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

// Utilities:
import TopicConfigContext from 'utilities/topicConfigContext';

const styles = {
    '&.MuiDialogTitle-root': {
        padding: '1rem',
    },
};

const MissingSuppressed = ({
    missingSuppressedModalOpen,
    setMissingSuppressedModalOpen,
}) => {
    const { topic } = useContext(TopicConfigContext);

    return (
        <div>
            <Dialog
                onClose={() => setMissingSuppressedModalOpen(false)}
                aria-labelledby="about-data-dialogue"
                open={missingSuppressedModalOpen}
            >
                <MuiDialogTitle
                    sx={styles}
                    id="about-data-title"
                    onClose={() => setMissingSuppressedModalOpen(false)}
                >
                    Missing / Suppressed Data
                </MuiDialogTitle>
                <MuiDialogContent dividers>
                    <Typography component="div" gutterBottom>
                        <Typography variant="h6" component="p">
                            Missing Data:
                        </Typography>
                        <p>
                            Missing data refers to data that either have not
                            been collected or were not available for analysis.
                        </p>

                        {(topic.countySuppressionRuleRange ||
                            topic.subCountySuppressionRuleRange) && (
                            <>
                                <Typography variant="h6" component="p">
                                    Suppressed Data:
                                </Typography>
                                <p>
                                    Suppressed data refers to data that are
                                    intentionally not displayed to protect
                                    patient confidentiality and/or because the
                                    estimates are considered statistically
                                    unreliable. 
                                </p>
                                {/* Leaving in place - this is to display individual suppression rules on a by topic basis.
                                Was recently changed, but a decision could be made that reverts to this original approach.                             
                            <ul>
                                {topics[topic].countySuppressionRules && (
                                    <li>
                                        {`Data values are suppressed for a county if the counts are from
                                                    ${topics[topic].countySuppressionRules.range} or the population
                                                    denominator is < ${topics[topic].countySuppressionRules.populationMin}.`}
                                    </li>
                                )}
                                {topics[topic].subCountySuppressionRules && (
                                    <li>
                                        {`Data values are suppressed for a zip code or a census tract if the counts
                                                    are from ${topics[topic].subCountySuppressionRules.range} or the population
                                                    denominator is < ${topics[topic].subCountySuppressionRules.populationMin}.`}
                                    </li>
                                )}
                                </ul>{' '} */}
                            </>
                        )}
                        <p>
                            For more information, please visit the topic&apos;s{' '}
                            <a href={`/ephtportal/${topic.topicUrlPath}`}>
                                Overview
                            </a>{' '}
                            page under &quot;About These Data.&quot;
                        </p>
                    </Typography>
                </MuiDialogContent>
                <MuiDialogActions>
                    <Button
                        autoFocus
                        onClick={() => setMissingSuppressedModalOpen(false)}
                        color="primary"
                    >
                        Close
                    </Button>
                </MuiDialogActions>
            </Dialog>
        </div>
    );
};

export default MissingSuppressed;
